import type {StoreId} from "../../stem-core/state/State";
import {Dispatchable} from "../../stem-core/base/Dispatcher";
import {getQueryParam} from "../UtilsLib.js";


// TODO @flow @auth this should be removed
class SocialAuthService extends Dispatchable {
    declare merchantId?: StoreId;
    constructor() {
        super();
        this.merchantId = getQueryParam("clientId");
    }

    setMerchantId(merchantId: StoreId) {
        this.merchantId = merchantId;
        this.dispatchChange();
    }
}

export const socialAuthService = new SocialAuthService();
